import { DotTypes } from "../types";

export default {
  dots: "dots",
  bubblyDots: "bubbly-dots",
  circuitChip: "circuit-chip",
  rounded: "rounded",
  classy: "classy",
  classyRounded: "classy-rounded",
  square: "square",
  extraRounded: "extra-rounded",
  hexagon: "hexagon",
  octagon: "octagon"
} as DotTypes;
